import { Mic } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { VOICE_MESSAGE_NAME_PREFIX } from '@avanta/shared/constants/chat';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import type { MessageFile } from '@avanta/shared/types/chat';

interface AudioMessageProps {
  file: MessageFile['file'];
  showName?: boolean;
}

export const AudioMessage = ({ file, showName = true }: AudioMessageProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  return (
    <span className="flex min-w-0 w-full flex-col gap-2">
      {showName && (
        <span className="text-sm text-gray-500">
          {file.name.startsWith(VOICE_MESSAGE_NAME_PREFIX) ? (
            <span className="flex items-center gap-1">
              <Mic className="size-4" />
              <span className="text-sm text-gray-500">{t('Chat.Messages.voiceNote')}</span>
            </span>
          ) : (
            file.name
          )}
        </span>
      )}
      <audio src={file.url} controls className="block w-full min-w-60">
        <track kind="captions" />
      </audio>
    </span>
  );
};
